import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useOptions} from './';

const defaultEdapOptions = {
    searchSubmitEventActionLocation: 'search-widget',
    searchQuerySubmittedEventActionLocation: undef,
    destinationSummaryClickEventAction: undef,
    destinationSummaryClickEventCategory: undef,
    submitSummaryClickEventAction: undef,
    submitSummaryClickEventCategory: undef,
    detailsModalCloseEventAction: undef,
    detailsModalCloseEventCategory: undef
};

const fixedEdapOptions = {
    searchSubmitEventName: 'search.submit',
    datedSearchSubmitEventName: 'dated.search.submit',
    searchQuerySubmittedEventName: 'search_query.submitted'
};

function useEdapOptions(props) {
    const {
        edapOptions: propsEdapOptions
    } = props;

    const {
        options: edapOptions
    } = useOptions(defaultEdapOptions, propsEdapOptions, fixedEdapOptions);

    const result = {
        edapOptions
    };

    useDebugValue(result);

    return result;
}

export {useEdapOptions};
